const Vue    = require('vue')

const App    = require('./app.vue')
const router = require('./router')
const store  = require('./store')

Vue.filter('time', require("./filter/time.js"))

const app = new Vue(
	Vue.util.extend({router, store}, App)
)

module.exports = {app, router, store}



// WEBPACK FOOTER //
// ./src/app.js